import { render, staticRenderFns } from "./UserFamilyForm.vue?vue&type=template&id=7f3e49f8&"
import script from "./UserFamilyForm.vue?vue&type=script&lang=js&"
export * from "./UserFamilyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports